<template>
    <div>
        <div class="w-100 border-light mb-4" v-show="files && files.length > 0">
            <div v-if="error" class="alert alert-danger"><strong>Error!</strong> {{ error }}</div>

            <div v-if="success" class="alert alert-success">
                <strong>Success!</strong> Your document was saved
            </div>

            <div v-if="loading" class="loading-container">
                <i class="fa fa-spin fa-circle-o-notch mr-2"></i>
            </div>

            <table class="table">
                <colgroup>
                    <col span="1" style="width: 60.0%;" />
                    <col span="1" style="width: 40.0%;" />
                </colgroup>
                <thead class="thead-light">
                    <tr>
                        <th scope="col">File</th>
                        <th scope="col">Modified</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="file in files" :key="file.id">
                        <td>
                            <a
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:href="file.file_url"
                                v-bind:title="file.file_name"
                            >
                                <i :class="file.file_url ? 'fa fa-file' : ''"></i>
                                {{ file.file_name }}
                            </a>
                        </td>
                        <td>
                            {{ file.updated_at }} by
                            <span class="text-danger">{{ file.last_modified_by }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
import ProfilePicture from "../ui/ProfilePicture";
import { fixDatePickers } from "../../plugins/fixDatePickers";

export default {
    name: "CompanyDocuments",
    props: ["organization"],
    mixins: [fixDatePickers],
    components: {
        ModalComponent,
        ProfilePicture,
    },
    data() {
        return {
            files: [],
            error: null,
            success: false,
            loading: false,
        };
    },
    mounted() {},
    watch: {
        organization() {
            this.getFilesData();
        },
    },
    methods: {
        getFilesData() {
            this.loading = true;
            this.error = null;
            axios
                .get(`/api/organizations/${this.organization.id}/company-documents`)
                .then(r => {
                    this.files = r.data.data;
                    this.error = null;
                    this.loading = false;
                    $('[data-toggle="tooltip"]').tooltip();
                })
                .catch(e => {
                    this.error = "Could not retrieve internal files. Server error.";
                    this.loading = false;
                    $('[data-toggle="tooltip"]').tooltip();
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
